import { useState } from "react";
import type { ReactNode } from "react";
import styles from "./simpleTabs.module.scss";

interface TabDef {
  key: string;
  /** Usually a plain string; accepts a node so a tab can carry a marker (e.g. a change dot). */
  label: ReactNode;
  children: ReactNode;
}

interface SimpleTabsProps {
  tabs: TabDef[];
}

export function SimpleTabs({ tabs }: SimpleTabsProps) {
  const [activeKey, setActiveKey] = useState(() => tabs[0]?.key ?? "");
  const [mounted, setMounted] = useState<Set<string>>(
    () => new Set(tabs[0]?.key ? [tabs[0].key] : []),
  );

  const handleTabClick = (key: string) => {
    setMounted((prev) => (prev.has(key) ? prev : new Set([...prev, key])));
    setActiveKey(key);
  };

  return (
    <div className={styles.tabs}>
      <div className={styles.tabBar}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab.key)}
            className={activeKey === tab.key ? styles.tabActive : styles.tab}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {tabs.map((tab) =>
        mounted.has(tab.key) ? (
          <div
            key={tab.key}
            className={activeKey === tab.key ? styles.tabPanel : styles.tabPanelHidden}
          >
            {tab.children}
          </div>
        ) : null,
      )}
    </div>
  );
}
